import { useCallback } from 'react';
import { CuboidBase, CuboidStyleHandlers } from '../types';

export const useMakeStyledCuboid = <CuboidT extends CuboidBase>({
  makeCuboidStyles,
}: CuboidStyleHandlers<CuboidT>) => {
  const makeStyledCuboid = useCallback(
    (cuboid: CuboidT) => {
      const styles = makeCuboidStyles(cuboid);
      const { id, name, position, rotation, scale } = cuboid;
      return {
        id,
        name: name ?? id,
        position,
        rotation,
        scale,
        ...styles,
        cuboidData: cuboid,
      };
    },
    [makeCuboidStyles]
  );

  return makeStyledCuboid;
};
